<div class="container">
    <div class="loader"></div>
    <h1>Please wait...</h1>
</div>
